{
  "name": "pialhambrafront",
  "version": "2.0.0-alpha.1",
  "author": "Pindocer",
  "description": "Aplikacja Pidocer.",
  "license": "license.txt",
  "scripts": {
    "ng": "ng",
    "start": "nx serve --disable-host-check",
    "build": "nx build",
    "watch": "nx build --watch --configuration development",
    "test": "nx test",
    "lint": "eslint \"{src,apps,libs,test}/**/*.ts\" --fix",
    "docs:json": "compodoc -p ./tsconfig.json -e json -d .",
    "api:contract": "node tools/api-contract/scan-code.mjs && node tools/api-contract/compare.mjs && node tools/api-contract/entities.mjs && node tools/api-contract/compare-shapes.mjs && node tools/api-contract/generate-endpoints.mjs",
    "mjmlwatch": "mjml --watch email-templates/*.mjml --output email-templates/",
    "mjmldevserver": "live-server --host=localhost --open=email-templates",
    "mjmldev": "concurrently \"pnpm run mjmlwatch\" \"pnpm run mjmldevserver\" ",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org ilandpeak-5f --project pialhambrafront ./dist && sentry-cli sourcemaps upload --org ilandpeak-5f --project pialhambrafront ./dist",
    "pre:patch": "standard-version --prerelease dev --release-as patch",
    "pre:minor": "standard-version --prerelease dev --release-as minor",
    "pre:major": "standard-version --prerelease dev --release-as major",
    "release:patch": "standard-version --release-as patch",
    "release:minor": "standard-version --release-as minor",
    "release:major": "standard-version --release-as major",
    "postinstall": "electron-builder install-app-deps && electron-builder install-app-deps",
    "electron:start:local": "concurrently \"nx run pindocer:serve\" \"nx run pialhambrafront:serve:electron-local\"",
    "electron:build:pi2": "nx run-many --target=build --configuration=electron-pi2 --projects=tag:electron --parallel=8",
    "electron:build:pi3": "nx run-many --target=build --configuration=electron-pi3 --projects=tag:electron --parallel=8",
    "electron:build:stage": "nx run-many --target=build --configuration=electron-stage --projects=tag:electron --parallel=8",
    "electron:build:2-stage": "nx run-many --target=build --configuration=electron-2-stage --projects=tag:electron --parallel=8",
    "electron:make:pi2": "nx run-many --target=build --configuration=electron-pi2 --projects=tag:electron --parallel=8 && nx run pindocer:make:pi2",
    "electron:make:pi3": "nx run-many --target=build --configuration=electron-pi3 --projects=tag:electron --parallel=8 && nx run pindocer:make:pi3",
    "electron:make:stage": "nx run-many --target=build --configuration=electron-stage --projects=tag:electron --parallel=8 && nx run pindocer:make:stage",
    "electron:make:2-stage": "nx run-many --target=build --configuration=electron-2-stage --projects=tag:electron --parallel=8 && nx run pindocer:make:2-stage",
    "deploy:web": "./deploy-web.sh",
    "deploy:test-pindocer": "firebase deploy --only hosting:test-pindocer",
    "deploy:v2": "firebase deploy --only hosting:pindocer-v2",
    "prepare:electron:stage": "nx run pialhambrafront:build --configuration=electron-stage --skip-nx-cache && nx run pindocer-file-worker:build --configuration=electron-stage --skip-nx-cache && nx run pindocer:build --configuration=electron-stage --skip-nx-cache",
    "prepare:electron:2-stage": "nx run pialhambrafront:build --configuration=electron-2-stage --skip-nx-cache && nx run pindocer-file-worker:build --configuration=electron-2-stage --skip-nx-cache && nx run pindocer:build --configuration=electron-2-stage --skip-nx-cache",
    "dist:pi2": "V=$(node -p \"require('./package.json').version\") && nx run pialhambrafront:build:pi2 --skip-nx-cache && rm -f pi2-prod-$V.zip && (cd dist/apps/pialhambrafront && zip -r ../../../pi2-prod-$V.zip .)",
    "dist:pi3": "V=$(node -p \"require('./package.json').version\") && nx run pialhambrafront:build:pi3 --skip-nx-cache && rm -f pi3-prod-$V.zip && (cd dist/apps/pialhambrafront && zip -r ../../../pi3-prod-$V.zip .)",
    "dist:prod": "npm run dist:pi2 && npm run dist:pi3",
    "api:record": "node tools/api-contract/record-stage.mjs && node tools/api-contract/compare-shapes.mjs && node tools/api-contract/generate-dto.mjs",
    "api:record:write": "node tools/api-contract/record-stage-write.mjs && node tools/api-contract/compare-shapes.mjs",
    "api:dto": "node tools/api-contract/generate-dto.mjs",
    "api:endpoints": "node tools/api-contract/generate-endpoints.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.9",
    "@angular/cdk": "21.2.9",
    "@angular/common": "21.2.9",
    "@angular/compiler": "21.2.9",
    "@angular/core": "21.2.9",
    "@angular/forms": "21.2.9",
    "@angular/material": "21.2.9",
    "@angular/platform-browser": "21.2.9",
    "@angular/platform-browser-dynamic": "21.2.9",
    "@angular/router": "21.2.9",
    "@auth0/angular-jwt": "~5.1.2",
    "@microsoft/signalr": "~8.0.0",
    "@nestjs/common": "^10.0.2",
    "@nestjs/core": "^10.0.2",
    "@nestjs/microservices": "^10.0.0",
    "@nestjs/schedule": "^4.0.0",
    "@ng-select/ng-select": "21.8.2",
    "@ngneat/until-destroy": "~10.0.0",
    "@ngx-translate/core": "~14.0.0",
    "@ngx-translate/http-loader": "~7.0.0",
    "@sentry/angular": "10.53.1",
    "@sentry/electron": "7.13.0",
    "@types/better-queue": "^3.8.6",
    "@types/better-sqlite3": "^7.6.12",
    "@types/jsonwebtoken": "^9.0.9",
    "angular-svg-icon": "19.1.1",
    "better-queue": "^3.8.12",
    "better-sqlite3": "^11.9.1",
    "chokidar": "5.0.0",
    "d3": "^7.9.0",
    "date-fns": "~2.30.0",
    "deep-object-diff": "^1.1.9",
    "electron-dl": "^3.5.2",
    "electron-log": "^5.3.1",
    "electron-updater": "^6.3.9",
    "eventemitter2": "^6.4.9",
    "filesize": "~10.1.0",
    "jsonwebtoken": "^9.0.2",
    "lodash": "~4.17.21",
    "nedb-promises": "^6.2.3",
    "ngx-bootstrap": "21.2.0",
    "ngx-infinite-scroll": "21.0.0",
    "ngx-toastr": "20.0.5",
    "qrcode": "^1.5.4",
    "reflect-metadata": "^0.1.13",
    "rxjs": "~7.8.2",
    "simplebar": "~6.2.5",
    "simplebar-angular": "~3.2.4",
    "slugify": "^1.6.6",
    "source-map-support": "^0.5.21",
    "tslib": "~2.6.2",
    "typeorm": "^0.3.22",
    "web-animations-js": "~2.3.2",
    "xxhash-wasm": "^1.1.0",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/core": "21.2.9",
    "@angular-devkit/schematics": "21.2.9",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/build": "21.2.9",
    "@angular/cli": "21.2.12",
    "@angular/compiler-cli": "21.2.9",
    "@angular/language-service": "21.2.9",
    "@babel/core": "~7.29.0",
    "@compodoc/compodoc": "~1.1.23",
    "@nx/angular": "22.7.2",
    "@nx/devkit": "22.7.2",
    "@nx/esbuild": "22.7.2",
    "@nx/eslint": "22.7.2",
    "@nx/eslint-plugin": "22.7.2",
    "@nx/jest": "22.7.2",
    "@nx/js": "22.7.2",
    "@nx/web": "22.7.2",
    "@nx/webpack": "22.7.2",
    "@nx/workspace": "22.7.2",
    "@schematics/angular": "21.2.9",
    "@sentry/cli": "^2.43.0",
    "@swc-node/register": "1.11.1",
    "@swc/cli": "0.7.10",
    "@swc/core": "1.15.8",
    "@swc/helpers": "0.5.21",
    "@types/d3": "^7.4.3",
    "@types/jest": "30.0.0",
    "@types/lodash": "~4.17.16",
    "@types/node": "^18.16.9",
    "@types/qrcode": "^1.5.6",
    "@typescript-eslint/eslint-plugin": "7.18.0",
    "@typescript-eslint/parser": "7.18.0",
    "@typescript-eslint/utils": "7.18.0",
    "babel-loader": "~8.3.0",
    "concurrently": "~8.2.2",
    "electron": "^34.0.0",
    "electron-builder": "26.15.3",
    "esbuild": "^0.19.2",
    "eslint": "8.57.1",
    "eslint-config-prettier": "10.1.8",
    "jest": "30.4.2",
    "jest-environment-jsdom": "30.4.1",
    "jest-preset-angular": "16.0.0",
    "jsdom": "26.1.0",
    "jsonc-eslint-parser": "^2.1.0",
    "live-server": "~1.2.2",
    "mjml": "~4.15.3",
    "ng-packagr": "21.2.3",
    "nx": "22.7.2",
    "nx-electron": "22.0.0",
    "postcss": "^8.4.5",
    "prettier": "~2.8.8",
    "sass": "^1.68.0",
    "sass-loader": "16.0.8",
    "standard-version": "^9.5.0",
    "style-loader": "^3.3.3",
    "ts-jest": "29.4.9",
    "ts-loader": "^9.5.1",
    "ts-node": "~10.9.2",
    "typescript": "5.9.3",
    "vitest": "^4.1.11",
    "webpack": "5.101.3",
    "webpack-cli": "^5.1.4"
  },
  "pnpm": {
    "overrides": {
      "browserslist": "4.28.2",
      "tablesort": "5.6.0"
    },
    "onlyBuiltDependencies": [
      "@compodoc/compodoc",
      "@nestjs/core",
      "@parcel/watcher",
      "@sentry/cli",
      "@swc/core",
      "better-sqlite3",
      "electron",
      "esbuild",
      "fsevents",
      "less",
      "lmdb",
      "msgpackr-extract",
      "nx",
      "unrs-resolver"
    ]
  },
  "packageManager": "pnpm@10.33.4"
}
